module.exports = __webpack_public_path__ + "site-27.jpg?c6df0188ed6d9a29ffa7008cbf9532fd";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/portfolio/site-27.jpg
 ** module id = 133
 ** module chunks = 0
 **/